import {TimeUtils} from '@colonist/utils'
import {StorageWrapper} from '../../../shared/scripts/StorageWrapper'
import {ClientUserState} from '../../../shared/scripts/ClientUserState'
import {ViewPopup} from '../../../shared/scripts/ui_popup/ViewPopup'
import {UIMRequestPushNotificationOnLoadHomePagePopup} from '../ui_popup/UIMRequestPushNotificationOnLoadHomePagePopup'
import {UIMRequestPushNotificationOnFriendRequestPopup} from '../ui_popup/UIMRequestPushNotificationOnFriendRequestPopup'

export const USER_ACTION_ENUM = {
    USER_REJECTED_PUSH_NOTIFICATION: 0,
    USER_ACCEPTED_PUSH_NOTIFICATION: 1,
}

export enum PushNotificationPopupIntentEnum {
    OnLoadHomePage = 'ON_LOAD_HOME_PAGE',
    OnUserSentFriendRequest = 'ON_USER_SENT_FRIEND_REQUEST',
}

export interface PushNotificationPopupType {
    intent: PushNotificationPopupIntentEnum
    frequency: number
    showNotificationPopup: () => ViewPopup
}

export const pushNotificationPopupData: PushNotificationPopupType[] = [
    {
        intent: PushNotificationPopupIntentEnum.OnLoadHomePage,
        frequency: TimeUtils.MILLISECONDS * TimeUtils.SECONDS_IN_MINUTE * TimeUtils.MINUTES_IN_HOUR * TimeUtils.HOURS_IN_DAY * TimeUtils.DAYS_IN_WEEK,
        showNotificationPopup: () => new UIMRequestPushNotificationOnLoadHomePagePopup(),
    },
    {
        intent: PushNotificationPopupIntentEnum.OnUserSentFriendRequest,
        frequency: TimeUtils.MILLISECONDS * TimeUtils.SECONDS_IN_MINUTE * TimeUtils.MINUTES_IN_HOUR * TimeUtils.HOURS_IN_DAY,
        showNotificationPopup: () => new UIMRequestPushNotificationOnFriendRequestPopup(),
    },
]
export class UIMRequestPushNotificationController {
    static showRequestPushNotification(intent: PushNotificationPopupIntentEnum) {
        if(!this.shouldRequestPushNotification(intent)) return
        this.updateTimestampData(intent)

        const popupType = pushNotificationPopupData.find((popup) => popup.intent === intent)
        if(!popupType) return
        popupType.showNotificationPopup()
    }

    private static updateTimestampData(intent: PushNotificationPopupIntentEnum) {
        const timestampData = StorageWrapper.getRequestPushNotificationTimeData()
        const newTimestampData = {
            ...timestampData,
            [intent]: new Date(),
        }
        StorageWrapper.setRequestPushNotificationTimeData(newTimestampData)
    }

    private static shouldRequestPushNotification(intent: PushNotificationPopupIntentEnum): boolean {
        const hasUserBypassedLogin = StorageWrapper.getIfUserBypassedLogin()
        const isUserLoggedIn = ClientUserState.userState?.isLoggedIn
        if(!hasUserBypassedLogin && !isUserLoggedIn) return false

        const hasUserAcceptedPushNotification = StorageWrapper.getPushNotificationRequestStatus()
        if(hasUserAcceptedPushNotification) return false

        const hasUserBeenPromptedRecentlyForSameIntent = this.hasUserBeenPromptedRecentlyForSameIntent(intent)
        if(hasUserBeenPromptedRecentlyForSameIntent) return false

        const hasUserBeenPromptedRecently = this.hasUserBeenPromptedRecently()
        if(hasUserBeenPromptedRecently) return false

        return true
    }

    private static getLatestPopupTimestamp(): number {
        const allTimestamps = Object.values(StorageWrapper.getRequestPushNotificationTimeData())
            .filter((date) => date != null)
            .map((date) => new Date(date).valueOf())

        if(allTimestamps.length == 0) return 0

        return Math.max(...allTimestamps)
    }

    private static hasUserBeenPromptedRecentlyForSameIntent(intent: PushNotificationPopupIntentEnum): boolean {
        const timestampData = StorageWrapper.getRequestPushNotificationTimeData()
        const lastRequestPushNotificationTime = timestampData[intent]
        if(lastRequestPushNotificationTime == null) return false

        const frequency = pushNotificationPopupData.find((popup) => popup.intent === intent)?.frequency
        if(frequency == undefined) return false

        return new Date().valueOf() - new Date(lastRequestPushNotificationTime).valueOf() < frequency
    }

    private static hasUserBeenPromptedRecently(): boolean {
        const latestPopupTimestamp = this.getLatestPopupTimestamp()
        if(latestPopupTimestamp == 0) return false

        const minimumGapBetweenAnyPopups = TimeUtils.MILLISECONDS * TimeUtils.SECONDS_IN_MINUTE * TimeUtils.MINUTES_IN_HOUR * TimeUtils.HOURS_IN_DAY
        return new Date().valueOf() - latestPopupTimestamp < minimumGapBetweenAnyPopups
    }
}
